module.exports = __webpack_public_path__ + "static/media/hepatitis3.bde0a77a.webp";